<div class="lets-talk">
	<h2>Let's Talk</h2>
	<button (click)="scrollToTarget()">SCHEDULE A DEMO</button>
</div>
<div class="wrapper">
	<div class="typing-container">
		<h2 style="margin-left: 40px; margin-right: 40px;">Instant insights, just add people!</h2>
	</div>
	<div class="wrapper-container">
		<div class="div-block-85">
			<div class="qr-code-block">
				<div class="imageContainer">
					<img src="/assets/images/qr-code-yellow.png"  loading="lazy" alt="" class="image-44" />
				</div>
				<p>
					People
					<strong>scan</strong>
					a code
					<br />
					(or click a link)
				</p>
			</div>
			<div class="phone-block">
				<div class="div-block-86">
					<div class="midImageContainer">
						<img src="/assets/images/workflow_right_screen.png"    loading="lazy" alt="" />
						<h4 >Audio</h4>
					</div>
					<div class="midImageContainer">
						<img src="/assets/images/workflow_middle_screen.png"  loading="lazy" alt="" />
						<h4 >Video</h4>
					</div>
					<div class="midImageContainer">
						<img src="/assets/images/workflow_left_screen.png"  loading="lazy" alt="" />
						<h4>Text</h4>
					</div>
				</div>
				<p>
					They
					<strong>answer</strong>
					a question
					<br />
					(browser or app)
				</p>
			</div>
			<div class="report-block">
				<div class="imageContainer">
					<img src="/assets/images/logistics.png" loading="lazy" alt="" />
				</div>
				<p style="max-width: 300px;">
					Jotto generates insightful
					<strong>reports</strong>
				</p>
			</div>
		</div>
	</div>
</div>
